import { ConfirmedBooking } from '@/types/api/services/booking';

export function isDealsBooking(booking: ConfirmedBooking) {
  return (booking.extra.campaigns || []).find((campagin) => campagin.type === 7 && campagin.publicationType === 2);
}
